<app-sub-navbar></app-sub-navbar>

<!-- Content -->

<section class="container-fluid my-md-4 bd-layout">
  <aside class="bd-sidebar">
    <nav class="collapse bd-links" id="filterz" aria-label="filterz">
      <ul class="list-unstyled mb-0 py-3 pt-md-1">
        <li class="mb-1">
          <a
            routerLink="/profile"
            class="btn d-inline-flex align-items-center rounded"
          >
            Profile
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/downloads"
            class="btn d-inline-flex align-items-center rounded"
          >
            Downloads
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/favorites"
            class="btn d-inline-flex align-items-center rounded"
          >
            Favorites
          </a>
        </li>

        <li class="mb-1">
          <a
            routerLink="/subscription"
            class="btn d-inline-flex align-items-center rounded"
          >
            Subscription
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <div class="container-fluid overflow-hidden">
    <div class="row">
      <div class="justify-content-between d-flex">
        <h3 class="fw-bold">Profile</h3>
        <button
          class="btn bd-sidebar-toggle d-md-none py-0 px-1 ms-3 order-3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#filterz"
          aria-controls="filterz"
          aria-expanded="false"
          aria-label="Toggle docs navigation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-expand"
            viewBox="0 0 16 16"
          >
            <title>Expand</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="bi bi-collapse"
            viewBox="0 0 16 16"
          >
            <title>Collapse</title>
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="py-3 justify-content-center">
      <div class="col-md-12 col-lg-10">
        <form
          class="needs-validation"
          novalidate
          role="form"
          [formGroup]="profileContent"
          #f="ngForm"
          (ngSubmit)="submitContent(profileContent.value, profileContent.valid)"
        >
          <div class="row">
            <div
              class="avatar-img mb-2 d-flex gap-4 align-items-center"
            >
            <div class="skeleton-wrapper" [class.loaded]="imgUrlLoad">
              
              <img
                class="rounded-circle skeleton--image me-3"
                [src]="photoURL || 'assets/img/avatar.png'"
                (error)="onImageError($event)"
                loading="lazy"
                alt="avatar"
              />
             <button
                  (click)="filePicker.click()"
                  type="button"
                  class="btn btn-ib-light rounded-3 py-2"
                >
                 Upload
                </button>
                <input
                  #filePicker
                  type="file"
                  (change)="addData($event.target['files'])"
                />


            </div>
              </div>

            <!-- <div class="upload-photo mb-3">
              
            </div> -->

            <div class="col-12 mb-3">
              <label for="username" class="form-label">Username</label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">&#64;</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Username"
                  value="{{ user.name }}"
                  formControlName="uname"
                />
              </div>
            </div>

            <div class="col-sm-6 mb-3">
              <label for="firstName" class="form-label">Full name</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                placeholder=""
                value="{{ user.name }}"
                formControlName="name"
                required
              />
            </div>
            <!-- 
            <div class="col-sm-6 mb-3">
              <label for="lastName" class="form-label">Last name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                placeholder=""
                value="{{ user.name }}"
                required
              />
            </div> -->

            <div class="col-sm-6 mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                placeholder=""
                value="{{ user.email }}"
                required
                readonly
                formControlName="email"
              />
            </div>

            <div class="col-sm-6 mb-3">
              <label for="website" class="form-label">Website</label>
              <input
                type="url"
                class="form-control"
                id="website"
                placeholder=""
                value=""
                required
                formControlName="web"
              />
            </div>

            <div class="col-sm-6 mb-3">
              <label for="location" class="form-label">Location</label>
              <input
                type="text"
                class="form-control"
                id="location"
                placeholder=""
                value=""
                formControlName="loc"
              />
            </div>

            <div class="col-sm-6 mb-3">
              <label for="job" class="form-label">Job</label>
              <input
                type="text"
                class="form-control"
                id="job"
                placeholder=""
                value=""
                formControlName="job"
              />
            </div>
          </div>

          <hr class="hr-divider my-4" />

          <h4 class="mb-3">Social Profiles</h4>

          <div class="row g-3 mb-2">
            <div class="col-md-6">
              <label for="behance" class="form-label">Behance</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fab fa-behance"></i>
                </span>
                <input
                  type="url"
                  class="form-control"
                  id="behance"
                  placeholder="https://behance.net/"
                  value=""
                  formControlName="behance"
                />
              </div>
            </div>

            <div class="col-md-6">
              <label for="dribble" class="form-label">Dribbble</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fab fa-dribbble"></i>
                </span>
                <input
                  type="url"
                  class="form-control"
                  id="dribble"
                  placeholder="https://dribbble.com/"
                  value=""
                  formControlName="dribble"
                />
              </div>
            </div>

            <div class="col-md-6">
              <label for="pinterest" class="form-label">Pinterest</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fab fa-pinterest"></i>
                </span>
                <input
                  type="url"
                  class="form-control"
                  id="pinterest"
                  placeholder="https://pinterest.com/"
                  value=""
                  formControlName="pinterest"
                />
              </div>
            </div>

            <div class="col-md-6">
              <label for="linkedin" class="form-label">Linkedin</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fab fa-linkedin"></i>
                </span>
                <input
                  type="url"
                  class="form-control"
                  id="linkedin"
                  placeholder="https://linkedin.com/"
                  value=""
                  formControlName="linkedin"
                />
              </div>
            </div>
          </div>

          <div class="py-3">
            <button #submitBtn class="btn btn-ib-black rounded-3" type="submit">
              Save Changes
            </button>
          </div>
        </form>
        <div class="alert alert-success" role="alert" *ngIf="message">
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</section>
